import React, { useState } from 'react';
import { arrayRemove, arrayUnion, doc, setDoc } from 'firebase/firestore';
import { Link } from 'react-router-dom';
import { db } from '../firebase';

import DocumentIcon from "./document";
import WhatsApp from "./whatsApp";
import Gala from "./gala";
import Season from "./season";
import Holiday from "./holiday";
import NewSeason from "./newSeason";


// >>> WERSJE PDF (czyste <Document/>):
import AdultContractDoc from "./adultContractDoc"
import ContractDoc from "./contractDoc";                  // zrefaktoruj analogicznie
import ParentStatementDoc from "./parentStatementDoc";    //   -||-
import RulesStatementDoc from "./rulesStatementDoc";      //   -||-
import JoinDecisionDoc from "./decisionDoc";              //   -||-
import JoinRequestDoc from "./joinRequestDoc";    

import { pdf } from '@react-pdf/renderer';

// <<<<<<<<<<<<<<

export default function ArchiveUser({u, locations, groups}) {
  const [on, setOn] = useState(false);
  const [whatsApp, setWhatsApp] = useState(false);
  const [gala, setGala] = useState(false);
  const [season, setSeason] = useState(false);
  const [newSeason, setNewSeason] = useState(false);
  const [holiday, setHoliday] = useState(false)

  // --- ZIP status ---
  const [zipping, setZipping] = useState(false);

  const copyToClipboard = (str) => {
    const el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    el.focus();
    document.execCommand('copy');
    document.body.removeChild(el);
  };

  const whatsAppSet = (s) => {
    setDoc(doc(db, "users", u?.uid), {
      subUsers: { [u?.user?.index]: { whatsApp: s } }
    }, {merge: true});
    setWhatsApp(false);
  };

  function numberToPolishWeekday(num) {
    const days = {1:"Poniedziałek",2:"Wtorek",3:"Środa",4:"Czwartek",5:"Piątek",6:"Sobota",7:"Niedziela"};
    return days[num] || "Niepoprawny numer dnia (1–7)";
  }

  const getGroups = () => {
    if (!locations) return null;
    return u?.user?.groups?.map(g => {
      const groupData = groups?.find(x => x?.id === g);
      if (!groupData) return null;

      const locationName = locations?.find(x => x?.id === groupData?.location_id)?.name;
      const dayData = groupData?.days?.[0];
      const dayInfo = dayData
        ? (dayData.custom_name
            ? dayData.custom_name
            : numberToPolishWeekday(dayData.weekDay) + " - " + dayData.startTime + " - " + dayData.endTime + " - " + groupData.type)
        : "";

      return (
        <div key={g} style={{display:'flex',gap:"8px"}}>
          <h3 style={{fontSize:"12px",color:"rgb(30,30,30)"}}>{locationName} - {dayInfo}</h3>
        </div>
      );
    });
  };

  const adultStatus = (u) => {
    setDoc(doc(db, "users", u?.uid), {
      subUsers: { [u?.user?.index]: { adult: true } }
    }, {merge: true});
  };

  const galaSet = (s) => {
    setDoc(doc(db, "users", u?.uid), {
      subUsers: { [u?.user?.index]: { gala: s } }
    }, {merge: true});
    setGala(false);
  };

  const tourSet = () => {
    setDoc(doc(db, "users", u?.uid), { tours: arrayUnion(2) }, {merge: true});
    setGala(false);
  };

  const newSeasonSet = (s) => {
    setDoc(doc(db, "users", u?.uid), {
      subUsers: { [u?.user?.index]: { newSeason: s } }
    }, {merge: true});
    setSeason(false);
  };

  const confSeason = (s) => {
    setDoc(doc(db, "users", u?.uid), {
      subUsers: { [u?.user?.index]: { confSeason: s } }
    }, {merge: true});
    setNewSeason(false);
  };

  const holidaySet = (s) => {
    setDoc(doc(db, "users", u?.uid), {
      subUsers: { [u?.user?.index]: { holiday: s } }
    }, {merge: true});
    setHoliday(false);
  };

  // ================== POBIERANIE DOKUMENTÓW DLA TEGO SUBUSERA ==================

  // helpery
  const sanitize = (s) => (s || "plik").replace(/[<>:"/\\|?*\x00-\x1F]/g, "_").trim();
  const dotToISO = (s) => {
    const m = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec((s || "").trim());
    if (!m) return null;
    const [, dd, mm, yyyy] = m;
    return `${yyyy}-${mm}-${dd}`;
  };

  // ustalenie podpisu i daty na poziomie konta (stary schemat)
  const accountSign = u?.acc?.sign || u?.acc?.parent?.sign || u?.acc?.parent?.signUrl || null;
  const accountDate = u?.acc?.date || ""; // np. "17.04.2025"

  // zbuduj „docs” pod stary schemat (wstrzykujemy sign/date z konta)
  const buildDocsForOld = (user, accSign, accDate) => {
    const base = { ...(user?.docs || {}) };
    if (!accSign) return base;

    const accDateISO = dotToISO(accDate || "") || accDate || "";

    base.contract = {
      ...(base.contract || {}),
      sign: base.contract?.sign || accSign,
      date: base.contract?.date || accDateISO || "",
      signed: true,
    };
    base.rules = {
      ...(base.rules || {}),
      sign: base.rules?.sign || accSign,
      date: base.rules?.date || accDateISO || "",
      signed: true,
    };
    base.parentStatement = {
      ...(base.parentStatement || {}),
      sign: base.parentStatement?.sign || accSign,
      date: base.parentStatement?.date || accDateISO || "",
      signed: true,
    };

    return base;
  };

  // zbuduj listę „jobs” = co wyrenderować do PDF dla TEGO subUsera
  const buildPdfJobsForUser = (participant, docs, acc, accSign, accDate) => {
    if (!accSign) return [];

    const dateStr = docs?.contract?.date || accDate || "";
    const jobs = [];

    // Wniosek (opcjonalnie)
    jobs.push({
      label: `Wniosek o dołączenie - ${participant?.displayName || ""}`,
      node: (
        <JoinDecisionDoc
          displayName={participant?.displayName}
          date={dateStr}
          signing={docs?.contract?.sign || accSign}
        />
      ),
      date: dateStr,
    });

    // (opcjonalny) JoinRequest – jeśli używasz
    jobs.push({
      label: `Wniosek - szczegóły - ${participant?.displayName || ""}`,
      node: (
        <JoinRequestDoc
          displayName={participant?.displayName}
          date={dateStr}
          signing={docs?.contract?.sign || accSign}
        />
      ),
      date: dateStr,
    });

    if (participant?.adult) {
      jobs.push({
        label: `Umowa (dorosły) - ${participant?.displayName || ""}`,
        node: (
          <AdultContractDoc
            user={participant}
            parent={acc?.parent}
            acc={acc}
            date={dateStr}
            signing={docs?.adultContract?.sign || accSign}
          />
        ),
        date: dateStr,
      });
    } else {
      jobs.push({
        label: `Umowa - ${participant?.displayName || ""}`,
        node: (
          <ContractDoc
            user={participant}
            parent={acc?.parent}
            acc={acc}
            date={dateStr}
            signing={docs?.contract?.sign || accSign}
          />
        ),
        date: dateStr,
      });

      jobs.push({
        label: `Oświadczenie rodzica - ${participant?.displayName || ""}`,
        node: (
          <ParentStatementDoc
            user={participant}
            parent={acc?.parent}
            acc={acc}
            date={dateStr}
            signing={docs?.parentStatement?.sign || accSign}
          />
        ),
        date: dateStr,
      });
    }

    // Regulamin (wyjątek z facility jeżeli stosujesz)
    if (acc?.facility_id !== "cfh66CW4jxFRMkU9AT5y") {
      jobs.push({
        label: `Regulamin - ${participant?.displayName || ""}`,
        node: (
          <RulesStatementDoc
            displayName={participant?.displayName}
            facility={acc?.facility_id}
            date={docs?.rules?.date || accDate}
            signing={docs?.rules?.sign || accSign}
          />
        ),
        date: docs?.rules?.date || accDate,
      });
    }

    // Tylko te, które faktycznie mają podpis/warunek
    return jobs.filter(j => !!j.node);
  };

  // handler ZIP tylko dla TEGO uczestnika
  const handleDownloadZipFor = async (participant) => {
    const acc = u?.acc;
    const accSign = accountSign;
    const accDate = accountDate;

    if (!accSign) {
      alert("Brak podpisu na profilu – brak dokumentów do pobrania.");
      return;
    }

    const docs = buildDocsForOld(participant, accSign, accDate);
    const jobs = buildPdfJobsForUser(participant, docs, acc, accSign, accDate);

    if (!jobs.length) {
      alert("Brak dokumentów do pobrania dla tego uczestnika.");
      return;
    }

    try {
      setZipping(true);

      // dynamiczne importy
      const jszipMod = await import("jszip");
      const JSZip = jszipMod.default || jszipMod;
      const fsMod = await import("file-saver");
      const saveAs = fsMod.saveAs || fsMod.default;

      const zip = new JSZip();
      const displayName = participant?.displayName || "Uczestnik";
      const baseName = sanitize(displayName);

      let added = 0;
      for (const job of jobs) {
        try {
          const blob = await pdf(job.node).toBlob();
          const dateISO = (job.date && (job.date.includes(".") ? dotToISO(job.date) : job.date)) || "";
          const suffix = dateISO ? `_${dateISO.slice(0,10)}` : "";
          // UWAGA: bez wewnętrznego folderu – pliki trafiają od razu do ZIP
          zip.file(`${sanitize(job.label)}${suffix}.pdf`, blob);
          added++;
        } catch (e) {
          console.warn("Pominięto dokument (render PDF):", job.label, e);
        }
      }

      if (!added) {
        alert("Nie udało się zbudować żadnego dokumentu.");
        return;
      }

      const archive = await zip.generateAsync({ type: "blob" });
      // nazwa ZIP = imię i nazwisko uczestnika (bez sufiksu „_dokumenty”)
      saveAs(archive, `${baseName}.zip`);
    } catch (e) {
      console.error("ZIP error:", e);
      alert("Nie udało się utworzyć archiwum ZIP.");
    } finally {
      setZipping(false);
    }
  };

  // ================== RENDER ==================
  return (
    <div style={{display:"flex",flexDirection:"column",gap:"5px",borderBottom:"1px solid rgb(30,30,30,0.15)",padding:"5px",minWidth:"90%",transition:"0.5s"}}>
      <div style={{display:"flex",alignItems:"center",gap:"10px",minWidth:"100%"}}>

        <div style={{display:'flex',alignItems:"center",gap:"8px",marginRight:"5px"}}>
          {/* ZAMIANA: zamiast linku do profilu — przycisk pobierania ZIP */}
          <div
            onClick={() => handleDownloadZipFor(u?.user)}
            title="Pobierz dokumenty (ZIP)"
            style={{
              display:"flex",alignItems:"center",height:"18px",width:"18px",
              borderRadius:"5px",padding:"4px",border:"2px solid #0045C7",
              transition:"0.6s",cursor: zipping ? "not-allowed" : "pointer",
              opacity: zipping ? 0.6 : 1, background:"transparent"
            }}
          >
            <img
              src={process.env.PUBLIC_URL + (zipping ? "/loader.png" : "/download.png")}
              alt=""
              style={{width:"25px"}}
            />
          </div>
        </div>

        <div style={{display:'flex',flexDirection:"column",width:"47.5%"}}>
          <h3 style={{fontSize:"12px",color:"rgb(30,30,30)"}}>{u?.user?.displayName}</h3>
          <h3 style={{fontSize:"11px",color:"rgb(50,50,50)",fontWeight:'normal'}}>{u?.acc?.parent?.displayName}</h3>
        </div>

        <div style={{display:'flex',flexDirection:"column",width:"47.5%"}}>
          <h3 style={{fontSize:"12px",color:"rgb(30,30,30)"}}>{u?.acc?.parent?.phone}</h3>
          <h3 style={{fontSize:"11px",color:"rgb(50,50,50)",fontWeight:'normal'}}>{u?.acc?.email}</h3>
        </div>

        <div style={{display:'flex',gap:"10px",marginRight:"5px"}}>
          <div
            style={{display:"flex",alignItems:"center",height:"18px",width:"18px",borderRadius:"5px",padding:"3px",transition:"0.6s",marginTop:"3px",cursor:"pointer"}}
            onClick={() => setOn(!on)}
          >
            <img src={on ? process.env.PUBLIC_URL + "/arrow_close.png" : process.env.PUBLIC_URL + "/arrow_open.png"} style={{width:"22px"}} alt="toggle" />
          </div>
        </div>
      </div>

      {on &&
        <div style={{display:"flex",flexDirection:"column",gap:"10px",width:"100%",transition:"0.5s",borderTop:"1px solid rgb(30,30,30,0.15)",paddingTop:"15px"}}>
          {getGroups()}

          <div style={{display:'flex',gap:"8px"}}>
            <h3 style={{fontSize:"12px",color:"rgb(30,30,30, 0.9)",fontWeight:"normal",width:"100px"}}>Data urodzenia:</h3>
            <h3 style={{fontSize:"12px",color:"rgb(30,30,30)"}}>{u?.user?.dateOfBirth}</h3>
            <h3 style={{fontSize:"12px",color:"rgb(30,30,30)"}}>{u?.user?.pesel}</h3>
          </div>

          <div style={{display:'flex',gap:"8px"}}>
            <h3 style={{fontSize:"12px",color:"rgb(30,30,30, 0.9)",fontWeight:"normal",width:"100px"}}>Odbiór na zajęcia:</h3>
            <h3 style={{fontSize:"12px",color:"rgb(30,30,30)"}}>
              {(u?.user?.pickUp && u?.user?.pickUp !== "brak")
                ? ((u?.user?.pickUp === "nie" || u?.user?.pickUp === "Nie") ? "Nie odbierać" : "Odebrać")
                  + ((u?.user?.class && u?.user?.class !== "brak") ? " " + u?.user?.class : "")
                : "Nie dotyczy"}
            </h3>
          </div>

          <div style={{display:'flex',gap:"8px"}}>
            <h3 style={{fontSize:"12px",color:"rgb(30,30,30, 0.9)",fontWeight:"normal",width:"100px"}}>ID użytkownika:</h3>
            <h3 style={{fontSize:"12px",color:"rgb(30,30,30)"}}>{u?.uid}</h3>
          </div>

          <div style={{display:'flex',gap:"8px",marginTop:"5px",marginBottom:"3px"}}>
            <div
              style={{display:"flex",alignItems:"center",height:"18px",width:"18px",borderRadius:"5px",padding:"4px",border:"2px solid #0045C7",transition:"0.6s",cursor:"pointer"}}
              onClick={(e) => { e?.stopPropagation(); copyToClipboard(u?.user?.displayName + " - " + u?.acc?.parent?.phone + " - " + u?.acc?.uid); }}
              title="Kopiuj: Imię i nazwisko – telefon – UID"
            >
              <img src={process.env.PUBLIC_URL + "/clipboard.png"} style={{width:"25px"}} alt="copy" />
            </div>

            <div
              style={{display:"flex",alignItems:"center",height:"18px",width:"18px",borderRadius:"5px",padding:"4px",border:"2px solid #0045C7",transition:"0.6s",cursor:"pointer"}}
              onClick={() => setWhatsApp(!whatsApp)}
            >
              <WhatsApp wth={"20px"} color="#0045C7"/>
            </div>

            <div
              style={{display:"flex",alignItems:"center",height:"18px",width:"18px",borderRadius:"5px",padding:"4px",border:"2px solid #0045C7",transition:"0.6s",cursor:"pointer"}}
              onClick={() => setSeason(!season)}
            >
              <Season wth={"20px"} color="#0045C7"/>
            </div>

            <div
              style={{display:"flex",alignItems:"center",height:"18px",width:"18px",borderRadius:"5px",padding:"4px",border:"2px solid #0045C7",transition:"0.6s",cursor:"pointer"}}
              onClick={() => setNewSeason(!newSeason)}
            >
              <NewSeason wth={"20px"} color="#0045C7"/>
            </div>
          </div>
        </div>
      }

      {whatsApp && (
        <div style={{display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column",gap:"10px",width:"100%",height:"100%",transition:"0.5s",backgroundColor:"rgb(30,30,30,0.5)",position:"fixed",top:0,left:0,zIndex:3000}} onClick={() => setWhatsApp(false)}>
          <div style={{display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column",gap:"10px",width:"300px",height:"200px",transition:"0.5s",backgroundColor:"rgb(250,250,250)",borderRadius:"5px"}} onClick={(e) => e.stopPropagation()}>
            <h3 style={{fontSize:"13px",color:"rgb(30,30,30, 0.9)",fontWeight:"bold"}}>WhatsApp:</h3>
            <div style={{display:"flex",justifyContent:"center",alignItems:"center",gap:"20px"}}>
              <WhatsApp wth={"30px"} color="#2e9428" curs={"pointer"} clickFunc={() => whatsAppSet("green")}/>
              <WhatsApp wth={"30px"} color="#e0b531" curs={"pointer"} clickFunc={() => whatsAppSet("send")}/>
              <WhatsApp wth={"30px"} color="#DC143C" curs={"pointer"} clickFunc={() => whatsAppSet("no")}/>
              <WhatsApp wth={"30px"} color="rgb(30,30,30)" curs={"pointer"} clickFunc={() => whatsAppSet("")}/>
            </div>
          </div>
        </div>
      )}

      {season && (
        <div style={{display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column",gap:"10px",width:"100%",height:"100%",transition:"0.5s",backgroundColor:"rgb(30,30,30,0.5)",position:"fixed",top:0,left:0,zIndex:3000}} onClick={() => setSeason(false)}>
          <div style={{display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column",gap:"10px",width:"300px",height:"200px",transition:"0.5s",backgroundColor:"rgb(250,250,250)",borderRadius:"5px"}} onClick={(e) => e.stopPropagation()}>
            <h3 style={{fontSize:"13px",color:"rgb(30,30,30, 0.9)",fontWeight:"bold"}}>Nowy sezon:</h3>
            <div style={{display:"flex",justifyContent:"center",alignItems:"center",gap:"20px"}}>
              <Season wth={"30px"} color="#2e9428" curs={"pointer"} clickFunc={() => newSeasonSet(true)}/>
              <Season wth={"30px"} color="#DC143C" curs={"pointer"} clickFunc={() => newSeasonSet(false)}/>
            </div>
          </div>
        </div>
      )}

      {newSeason && (
        <div style={{display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column",gap:"10px",width:"100%",height:"100%",transition:"0.5s",backgroundColor:"rgb(30,30,30,0.5)",position:"fixed",top:0,left:0,zIndex:3000}} onClick={() => setNewSeason(false)}>
          <div style={{display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column",gap:"10px",width:"300px",height:"200px",transition:"0.5s",backgroundColor:"rgb(250,250,250)",borderRadius:"5px"}} onClick={(e) => e.stopPropagation()}>
            <h3 style={{fontSize:"13px",color:"rgb(30,30,30, 0.9)",fontWeight:"bold"}}>Nowy sezon:</h3>
            <div style={{display:"flex",justifyContent:"center",alignItems:"center",gap:"20px"}}>
              <NewSeason wth={"30px"} color="#2e9428" curs={"pointer"} clickFunc={() => confSeason(true)}/>
              <NewSeason wth={"30px"} color="#DC143C" curs={"pointer"} clickFunc={() => confSeason(false)}/>
              <NewSeason wth={"30px"} color="rgb(30,30,30,0.5)" curs={"pointer"} clickFunc={() => confSeason("-")}/>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
